var exports = {
  "$": "Button__nL8kfy",
};

module.exports = exports;
